const BYTES_IN_MEGABYTE = 1024 * 1024;

export const MAX_MEDIA_MEGABYTES = 10;

export const MAX_MEDIA_BYTES = MAX_MEDIA_MEGABYTES * BYTES_IN_MEGABYTE;

export const MEDIA_TOO_LARGE_MESSAGE = `Arquivo acima do limite de ${MAX_MEDIA_MEGABYTES}MB. Envie um arquivo menor.`;

export function isWithinMediaSizeLimit(sizeInBytes: number): boolean {
  return sizeInBytes <= MAX_MEDIA_BYTES;
}

export const ALLOWED_MEDIA_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'video/mp4',
  'video/3gpp',
  'audio/aac',
  'audio/mp4',
  'audio/mpeg',
  'audio/amr',
  'audio/ogg',
];

export const ALLOWED_MEDIA_MIME_PREFIXES = ['application/', 'text/'];

export const MEDIA_TYPE_NOT_ALLOWED_MESSAGE =
  'Tipo de arquivo não aceito pelo WhatsApp. Envie imagem (JPEG ou PNG), vídeo (MP4 ou 3GP), áudio ou documento.';

export function isAllowedMediaType(mimeType: string): boolean {
  return (
    ALLOWED_MEDIA_MIME_TYPES.includes(mimeType) ||
    ALLOWED_MEDIA_MIME_PREFIXES.some(prefix => mimeType.startsWith(prefix))
  );
}

export const MEDIA_ACCEPT_ATTRIBUTE = [
  ...ALLOWED_MEDIA_MIME_TYPES,
  'application/pdf',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.csv',
  '.txt',
].join(',');
